export function formatCurrency(value: number, isUsd: boolean) {
	return new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: isUsd ? 'USD' : 'EUR',
		minimumFractionDigits: 0,
		notation: 'compact',
	}).format(value)
}
